import {
	ContractSuretyAccountUnderwritingModelSize,
	SuretyAccountId,
	SuretyType,
} from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../account.keys";

export const useAdminUpdateModelSize = (accountId: SuretyAccountId, suretyType: SuretyType) => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (modelSize: ContractSuretyAccountUnderwritingModelSize) =>
			await post(
				`/v2/admin/surety/accounts/${accountId}/${suretyType}/modelSize/${modelSize}`,
				{},
				"none",
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
		},
	});
	return {
		updateModelSize: mutation.mutate,
		updateModelSizeIsLoading: mutation.isPending,
		updateModelSizeError: mutation.error,
		updateModelSizeSuccess: mutation.isSuccess,
	};
};
